import React, { Component } from 'react';
import Modal from '../../../reusable/Modal/Modal.index';
import { FormattedMessage } from 'react-intl';

export default class UserAuditDownloadModal extends Component {

    render() {

        return (
            <div id={this.props.modalName} className='user-audit-download-modal'>

                <Modal closeButtonHandler={this.props.isModalLoading ? null : this.props.secondaryAction}
                       buttons={
                           [
                               {
                                   text:       <FormattedMessage
                                                   id={this.props.primaryI18n ? this.props.primaryI18n :
                                                       "General_CoreFunctionality_UIText_general.ok"} />,
                                   isDisabled: this.props.isModalLoading || this.props.isPrimaryButtonDisabled,
                                   click:      this.props.primaryAction,
                                   primary:    true
                               },
                               {
                                   text:       <FormattedMessage
                                                   id={this.props.secondaryI18n ? this.props.secondaryI18n :
                                                       "General_CoreFunctionality_UIText_general.cancel"} />,
                                   isDisabled: this.props.isModalLoading,
                                   click:      this.props.secondaryAction,
                                   tabIndex:   1
                               }
                           ]
                       }>

                    <div>
                        <h2 className="modal-header"><FormattedMessage id={this.props.title} /></h2>
                        <div className='modal-body-container'>
                            {this.props.children}
                        </div>
                    </div>

                </Modal>

            </div>
        )
    }

}


// WEBPACK FOOTER //
// ./src/scripts/pages/AccountUsage/Components/UserAuditDownloadModal.jsx